import * as React from 'react';
import {useEffect} from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import {GridRowModes, DataGrid, GridToolbarContainer, GridActionsCellItem, GridRowEditStopReasons, GridEditInputCell, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import Checkbox from "@mui/material/Checkbox";
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';


import ColorPicker from './ColorPicker.js';
import TableViewService from '../../services/tableview.service.js';
import MobileConfigEdit from './MobileConfigEdit';
import { useDispatch, useSelector } from "react-redux";

const initialRows = [
  {
    id: 1,
    SrNo:1,
    ParameterName: 'Column1 Description',
    Value: 'Sr.No.',
  },
  {
    id: 2,
    SrNo:2,
    ParameterName: 'Column2 Description',
    Value: 'Device Name',
  },
  {
    id: 3,
    SrNo:3,
    ParameterName: 'Column3 Description',
    Value: 'Tag Name',
  },
  {
    id: 4,
    SrNo:4,
    ParameterName: 'Column4 Description',
    Value: 'Tag Description',
  },
  {
    id: 5,
    SrNo:5,
    ParameterName: 'Column5 Description',
    Value: 'Block Namae',
  },
  {
    id: 6,
    SrNo:6,
    ParameterName: 'Column6 Description',
    Value: 'Block ID',
  },
  {
    id: 7,
    SrNo:7,
    ParameterName: 'Column7 Description',
    Value: 'Process Value',
  },
  {
    id: 8,
    SrNo:8,
    ParameterName: 'Column8 Description',
    Value: 'Unit',
  },
  {
    id: 9,
    SrNo:9,
    ParameterName: 'Column9 Description',
    Value: 'LoLo SP',
  },
  {
    id: 10,
    SrNo:10,
    ParameterName: 'Column10 Description',
    Value: 'Low SP',
  },
  {
    id: 11,
    SrNo:11,
    ParameterName: 'Column11 Description',
    Value: 'High SP',
  },
  {
    id: 12,
    SrNo:12,
    ParameterName: 'Column12 Description',
    Value: 'HiHi SP',
  },
  {
    id: 13,
    SrNo:13,
    ParameterName: 'Column13 Description',
    Value: 'Alarm Status',
  },
  {
    id: 14,
    SrNo:14,
    ParameterName: 'LoLo Alarm Color',
    Value: 'Red',
  },
  {
    id: 15,
    SrNo:15,
    ParameterName: 'Low Alarm Color',
    Value: 'Tomato',
  },
  {
    id: 16,
    SrNo:16,
    ParameterName: 'High Alarm Color',
    Value: 'Tomato',
  },
  {
    id: 17,
    SrNo:17,
    ParameterName: 'HiHi Alarm Color',
    Value: 'Red',
  },

  {
    id: 18,
    SrNo:18,
    ParameterName: 'Page Size',
    Value: 10,
  },

  
];


// Add form open for widgetConfig.
function EditToolbar(props) {
 const { setColorSelector, widgetName } = props;

  const handleClick = () => {
    //Console.log("Config button clicked")
  };

  //startIcon={<AddIcon />} 

  return (

      <Grid style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
        <Button color="primary" onClick={handleClick}>
          {widgetName} - Configuration
        </Button>
        <Button onClick={() => setColorSelector(true)} style={{ background: '#4a90e2', color: 'white', border: 'none', width: '120px', height: '30px', fontSize:'11px'}}> Color Picker </Button>
      
      </Grid>


    
  );
}

export default function WidgetConfig() {
  const { user } = useSelector((state) => state.auth);
  const widgetName = useSelector((state) => state.splitbutton1.widgetName);
  const [fetchData, setFetchData] = React.useState(true); // Fetch all row data enable bit
  
  const [rowsData, setRowsData] = React.useState([]);
  const [rowModesModel, setRowModesModel] = React.useState({});

  const [rowData, setRowData] = React.useState([]);
  const [saveData, setSaveData] = React.useState(false);
  const [addRecordForm, setAddRecordForm] = React.useState(false)
  const [editRecordForm, setEditRecordForm] = React.useState(false)
  const [editRowData, setEditRowData] = React.useState(false)

  const [colorSelector, setColorSelector] = React.useState(false)

  const [snackbar, setSnackbar] = React.useState(null); // if delete Success then set to success otherwise will set to fail
  const handleCloseSnackbar = () => setSnackbar(null);

 
  // Get all rows data present inside the table for specific value of the given column name  (dashboardName, columnName, columnValue)
  //Get configuration of the selected widget
  useEffect(() =>{
    async function getColumnData()  {
    try {

      let dashboardName = "TableMobileConfig";
      let columnName = "WidgetName";
      let columnValue = widgetName;
      //const offset = page * rowsPerPage;
      //console.log(page);
      //console.log(offset);
      //console.log(rowsPerPage);
      
      const response = await TableViewService.getColumnData(dashboardName, columnName, columnValue );
      //console.log(response.data);
      setRowsData(response.data);
      setFetchData(false);
      
    } catch (error) {
      console.log(error);

    }
  }

  getColumnData();



  }, [widgetName, fetchData]);


  const handleRecordEdited = (data) => {
    
    setEditRecordForm(false);
    setFetchData(true);  // reload the data again from backend
    
  };

  const handleEditClick = (params) => () => {
    //setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    //handleColorPaletteClick();
    setEditRowData(params);
    setEditRecordForm(true);

  };

  const handleRowDoubleClick = (params, event) => {
    //console.log(params);
    setEditRowData(params);
    setEditRecordForm(true);
  };

  const handleColorChanged = (data) => {
    
    setColorSelector(false);
    //console.log(data);
    
    
  };

 
  const columns = [
 
    { field: 'SrNo', headerName: 'Sr No', width: 30, type: 'number', align: 'center', headerAlign: 'center'},
    { field: 'ParameterName', headerName: 'Parameter Name', width: 200, align: 'center', headerAlign: 'center'},
    { field: 'Enable', headerName: 'Enable', type:'singleSelect', valueOptions: ['Enabled', 'Disabled'], width: 120, align: 'center', headerAlign: 'center', editable: true, },
    { field: 'Description', headerName: 'Column Description',  type: 'string',  width: 200, align: 'center', headerAlign: 'center',  editable: true,},
    { field: 'Width', headerName: 'Column Width',  type: 'string',  width: 200, align: 'center', headerAlign: 'center', editable: true, },
    { field: 'TextAlignment', headerName: 'Text Alignment', type: 'singleSelect', valueOptions: ['na', 'left', 'right', 'center'],  width: 200, align: 'center', headerAlign: 'center', editable: true, },
    { field: 'Color', headerName: 'Color',  type: 'string', width: 200, align: 'center', headerAlign: 'center', editable: true,
    renderCell: (params) => ( <button style={{ background: params.row.Color, color: 'black', border: 'none', width: '100px', height: '20px' }}> 
    {params.row.Color} </button> ), },
    { field: 'FontWeight', headerName: 'Font Weight',  type: 'singleSelect', valueOptions: ['na', 'normal', 'bold'], width: 200, align: 'center', headerAlign: 'center', editable: true, },
    { field: 'FontSize', headerName: 'Font Size',  type: 'number',  width: 200, align: 'center', headerAlign: 'center', editable: true,
      renderEditCell: (params) => (<GridEditInputCell{...params}inputProps={{min: 8, max: 40,}}/>), },
      { field: 'BorderStyle', headerName: 'Border Style',  type: 'string',  width: 200, align: 'center', headerAlign: 'center',  editable: true,},
    
    
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      width: 100,
      cellClassName: 'actions',
      getActions: (params) => {

        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(params)}
            color="inherit"
          />,
          
        ];
      },
    },
  ];

  return (
    <div>
    <Paper
      sx={{
        p: 1,
        margin: 'auto',
        maxWidth: '100%',
        maxHeight:1600,
        flexGrow: 1,
        backgroundColor: (theme) =>
          theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
      }}
    >
     
     <Box sx={{ height: 600 }}>
    
      <DataGrid
        rows={rowsData}
        getRowId={(rowsData) => rowsData._id} // This line will set id of the datagrid row = _id of the mongodb database, otherwisw error can occured.
        columns={columns}
        hideFooterPagination = {true}
        editMode="row"
        isCellEditable={(params) => {
          if (params.row.SrNo <= 13 && params.colDef.field === "Enable") {
            return true; // Enable editing for the "Enable" column 
          }
          if (params.row.SrNo <= 13 && params.colDef.field === "Description") {
            return true; // Enable editing for the "Description" column 
          }
          if (params.row.SrNo <= 13 && params.colDef.field === "Width") {
            return true; // Enable editing for the "Width" column 
          }
          if (params.row.SrNo <= 13 && params.colDef.field === "TextAlignment") {
            return true; // Enable editing for the "TextAlignment" column 
          }
          if ((params.row.SrNo == 14 || params.row.SrNo == 15 || params.row.SrNo == 19 || params.row.SrNo == 20 || params.row.SrNo >= 24) && params.colDef.field === "Color") {
            return true; // Enable editing for the "Color" column
          }
          
          if ((params.row.SrNo == 17 || params.row.SrNo == 22) && params.colDef.field === "FontWeight") {
            return true; // Enable editing for the "FontWeight" column
          }
          if ((params.row.SrNo == 16 || params.row.SrNo == 21) && params.colDef.field === "FontSize") {
            return true; // Enable editing for the "FontSize" column
          }
          
          if ((params.row.SrNo == 18 || params.row.SrNo == 23) && params.colDef.field === "BorderStyle") {
            return true; // Enable editing for the "BorderStyle" column 
          }

          if (params.row.SrNo >= 29 && params.colDef.field === "Enable") {
            return true; // Enable editing for the "Enable" column 
          }
                    
        }}
        //rowModesModel={rowModesModel}
        //onRowModesModelChange={handleRowModesModelChange}
        //onRowEditStop={handleRowEditStop}
        //processRowUpdate={processRowUpdate}

        onRowDoubleClick={handleRowDoubleClick} // Double click event handler
        slots={{
          toolbar: EditToolbar,
        }}
        slotProps={{
          toolbar: { setColorSelector, widgetName, },
        }}
      />
      </Box>

    
    {editRecordForm && (
      <MobileConfigEdit params = {editRowData} open= {editRecordForm} close = {handleRecordEdited} />
    )}


    {colorSelector && (
        <ColorPicker open= {colorSelector} close = {handleColorChanged} />
    )}

    {!!snackbar && (
          <Snackbar anchorOrigin={{ vertical:"top", horizontal:"center" }}  open onClose={handleCloseSnackbar} autoHideDuration={4000}>
            <Alert {...snackbar} onClose={handleCloseSnackbar} />
          </Snackbar>
    )}

      
    
    </Paper>

    </div>
    
  );
}